export const publishableKey = 'pk_live_51IgZ5fCF6cNYWN35RgV7EJHjv2K9Up5RO00eJgmHZguZPmuaOZtGRNz7Kv8EdMNrHQSQQUAKN3735mAZXMw2NJRJ00nohkVe10'